/* plx-reviews-more.js: hydrate /pages/reviews with every Judge.me review.

   The judgeme.review_widget_data product metafield is maintained by the
   Judge.me app and caches only the first 5 reviews per product, so the
   server-rendered grid (parlinx-testimonials.liquid, use_live) shows those.
   This script pages Judge.me's public widget endpoint (CORS *) for each
   product listed in the section's data block, drops anything already
   rendered (matched by uuid), and merges the rest into the grid newest-first
   using the same card markup (a <template> in the section). Any failure, at
   any point, leaves the server-rendered grid exactly as it was. */
(() => {
  'use strict';
  const grid = document.querySelector('[data-plx-quotes-grid]');
  const dataEl = document.querySelector('[data-plx-quotes-data]');
  const tpl = document.querySelector('[data-plx-quote-tpl]');
  if (!grid || !dataEl || !tpl || !('content' in tpl) || !window.fetch) return;

  let cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (_) { return; }
  const shop = String(cfg.shop || '');
  const products = (Array.isArray(cfg.products) ? cfg.products : []).filter((p) => p && p.id);
  if (!shop || !products.length) return;
  const have = new Set(Array.isArray(cfg.have) ? cfg.have : []);

  const API = 'https://api.judge.me/reviews/reviews_for_widget';
  const PER = 10;
  const MAX_PAGES = 20;

  /* mirrors the Liquid: remove "ParLinx P-1 " / "Parlinx " from the product title */
  const modelLabel = (t) => String(t || '').replace(/Par[Ll]inx( P-1)? /g, '').trim();

  const textOf = (html, fallback) => {
    if (html) {
      try {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return (doc.body.textContent || '').trim();
      } catch (_) { /* fall through */ }
    }
    return String(fallback || '').trim();
  };

  const card = (r) => {
    const f = tpl.content.firstElementChild.cloneNode(true);
    const rating = Math.max(0, Math.min(5, Math.round(Number(r.rating) || 0)));
    const stars = f.querySelector('.plx-quote__stars');
    if (stars) {
      stars.setAttribute('aria-label', rating + ' out of 5 stars');
      stars.querySelectorAll('.plx-quote__star').forEach((s, i) => {
        if (i + 1 > rating) s.classList.add('is-dim');
      });
    }
    const quote = f.querySelector('blockquote');
    if (quote) quote.textContent = textOf(r.body_html, r.body);
    const author = f.querySelector('.plx-quote__author');
    if (author) author.textContent = r.reviewer_name || 'Anonymous';
    const pill = f.querySelector('.plx-quote__pill');
    if (pill && !r.verified_buyer) pill.remove();
    const model = f.querySelector('.plx-quote__model');
    if (model) {
      const label = modelLabel(r.product_title);
      if (label) model.textContent = label; else model.remove();
    }
    f.dataset.createdAt = r.created_at || '';
    f.dataset.plxHydrated = '1';
    return f;
  };

  const fetchAll = async (p) => {
    const out = [];
    for (let page = 1; page <= MAX_PAGES; page++) {
      const url = API + '?url=' + encodeURIComponent(shop) +
        '&shop_domain=' + encodeURIComponent(shop) +
        '&platform=shopify&product_id=' + encodeURIComponent(p.id) +
        '&page=' + page + '&per_page=' + PER;
      const res = await fetch(url, { mode: 'cors', credentials: 'omit' });
      if (!res.ok) break;
      const d = await res.json();
      const revs = Array.isArray(d.reviews) ? d.reviews : [];
      out.push(...revs);
      const totalPages = d.pagination && Number(d.pagination.total_pages);
      if (revs.length < PER || (totalPages && page >= totalPages)) break;
    }
    return out;
  };

  /* SSR cards are newest-first (ISO timestamps compare lexicographically);
     keep that order for the merged set. */
  const insert = (fresh) => {
    fresh.sort((a, b) => String(b.created_at || '').localeCompare(String(a.created_at || '')));
    for (const r of fresh) {
      const el = card(r);
      const at = el.dataset.createdAt;
      let before = null;
      for (const sib of Array.from(grid.children)) {
        if (String(sib.dataset.createdAt || '') < at) { before = sib; break; }
      }
      grid.insertBefore(el, before);
    }
  };

  Promise.allSettled(products.map(fetchAll)).then((results) => {
    const fresh = [];
    for (const r of results) {
      if (r.status !== 'fulfilled') continue;
      for (const rev of r.value) {
        if (!rev || !rev.uuid || have.has(rev.uuid)) continue;
        have.add(rev.uuid);
        fresh.push(rev);
      }
    }
    if (fresh.length) insert(fresh);
    grid.dataset.plxHydrated = String(fresh.length);
  }).catch(() => { /* leave the SSR grid as-is */ });
})();
